import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import avatarImg from "../../../assets/images/default-user.webp";

export default function UserForm({ user, setShowForm, setData, data }) {
  const isEdit = !!user;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role_id: "",
    org_id: "",
    permissions: [],
    avatar: "",
    password: "",
  });

  // Initialize form
  useEffect(() => {
    if (user && data.roles && data.permissions) {
      setFormData({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        org_id: user.org_id || "",
        avatar: user.avatar ? `${process.env.REACT_APP_IMG_URL}/${user.avatar}` : "",
        role_id: user.role_id || "",
        permissions: user.permissions?.map((p) => p.id) || [],
        password: "",
      });
    }
  }, [user, data.roles, data.permissions]);

  const handleChange = (e) => {
    if (e.target.name === "avatar") {
      setFormData({ ...formData, avatar: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const apiFormData = new FormData();
      apiFormData.append("name", formData.name);
      apiFormData.append("email", formData.email);
      apiFormData.append("phone", formData.phone);

      if (formData.password) apiFormData.append("password", formData.password);
      if (formData.avatar instanceof File) apiFormData.append("avatar", formData.avatar);
      if (formData.role_id) apiFormData.append("role_id", String(formData.role_id));
      if (formData.org_id) apiFormData.append("org_id", String(formData.org_id));

      formData.permissions.forEach((p) => apiFormData.append("permissions[]", String(p)));

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/update-user/${user.id}`,
        apiFormData
      );

      const updatedUser = {
        ...response.data.user,
        role: data.roles?.find((role) => role.id == formData.role_id) || null,
        organization: data.organizations?.find((org) => org.id == formData.org_id) || null,
        permissions: data.permissions?.filter((perm) =>
          formData.permissions.includes(perm.id)
        ) || [],
      };

      setData((prev) => ({
        ...prev,
        users: prev.users.map((u) => (u.id === user.id ? updatedUser : u)),
      }));

      setShowForm(false);
    } catch (err) {
      console.error("Error saving user:", err.response?.data || err);
      alert(JSON.stringify(err.response?.data));
    }
  };

  const permissionOptions =
    data?.permissions?.map((p) => ({
      value: p.id,
      label: p.name.charAt(0).toUpperCase() + p.name.slice(1),
    })) || [];

  return (
    <form onSubmit={handleSubmit} className="update-form container">
      <h3 className="mb-4 text-center">{isEdit ? "Update User" : "Add User"}</h3>

      <div className="row">
        <div className="col-md-6">
          <div className="mb-3 text-center">
            <img
              src={
                typeof formData.avatar === "string"
                  ? formData.avatar
                  : formData.avatar
                  ? URL.createObjectURL(formData.avatar)
                  : avatarImg
              }
              alt="Avatar"
              style={{ width: "120px", height: "120px", borderRadius: "50%", objectFit: "cover" }}
            />
          </div>

          <div className="mb-3">
            <label>Avatar</label>
            <input type="file" className="form-control" name="avatar" onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label>Role</label>
            <select
              className="form-select"
              name="role_id"
              value={formData.role_id}
              onChange={handleChange}
            >
              <option value="">Select Role</option>
              {data.roles?.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label>Permissions</label>
            <Select
              isMulti
              options={permissionOptions}
              value={permissionOptions.filter((opt) => formData.permissions.includes(opt.value))}
              onChange={(selected) =>
                setFormData({
                  ...formData,
                  permissions: selected ? selected.map((s) => s.value) : [],
                })
              }
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <label>Name</label>
            <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label>Phone</label>
            <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label>Email</label>
            <input type="text" className="form-control" name="email" value={formData.email} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label>Organization</label>
            <select
              className="form-select"
              name="org_id"
              value={formData.org_id}
              onChange={handleChange}
            >
              <option value="">Select Organization</option>
              {data.organizations?.map((org) => (
                <option key={org.id} value={org.id}>
                  {org.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label>Password (optional)</label>
            <input type="password" className="form-control" name="password" value={formData.password} onChange={handleChange} />
          </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <button type="submit" className={`btn ${isEdit ? "btn-success" : "btn-success"}`}>
          {isEdit ? "Update User" : "Add User"}
        </button>
      </div>
    </form>
  );
}
